import axios from "axios";
import React, { useEffect, useState } from "react";
import { GET_TOKEN, GLOBAL_API } from "../../api/apiUrls";
import MenuIcon from "@mui/icons-material/Menu";
const TicketDahboard = ({
  serverURL,
  user,
  setShowSideOverlay,
  setPageViews,
  setNewPath,
}) => {
  const [locationOptions, setLocationOptions] = useState([]);

  const fetchBaseQuery = async (query) => {
    try {
      const res = await axios.post(GLOBAL_API, {
        mstr: query,
        tokenNumber: GET_TOKEN,
      });
      return res;
    } catch (err) {
      console.error("Error fetching data:", err);
      return null;
    }
  };

  const fetchLocationData = async () => {
    try {
      const query =
        "SELECT LocCode, locname FROM locmas WHERE LocCode NOT IN (15, 16, 17, 18, 19)";
      const res = await fetchBaseQuery(query);
      setLocationOptions(res?.data || []);
      // console.log("Location Data:", res?.data);
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  };

  useEffect(() => {
    fetchLocationData();
  }, []);

  return (
    <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
      <button
        className="btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none align-items-center gap-2"
        onClick={() => setShowSideOverlay(true)}
      >
        <MenuIcon />
      </button>
      <div className="headerUserDetails py-1 mb-3 d-flex justify-content-between">
        <span>Ticket Dashboard</span>
        <div
          className="d-flex gap-2 align-items-center"
          title={`Name: ${user.name} | Email: ${user.email}`}
        >
          <i className="fa fa-user"></i>
          <span>{user.name}</span>
        </div>
      </div>

      <div className="w-100 h-100 overflow-auto">
        <div className="container-fluid">
          {/* <p className="h2 fw-bold text-warning">Ticket Dashboard</p> */}
          <div className="row mb-3">
            {["Total", "Open", "Closed", "In-Process", "Re-Open"].map(
              (label, idx) => (
                <div className="col-md-3 mb-2" key={idx}>
                  <div className="card">
                    <div className="card-body">
                      <div className="col d-flex justify-content-between">
                        <p className="fs-3">{label} Tickets</p>
                        <p className="fs-2 fw-bold">23453</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>

          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Branch</th>
                      <th>Total</th>
                      <th>Open</th>
                      <th>Closed</th>
                      <th>In Process</th>
                      <th>Re Open</th>
                      <th>With in TAT</th>
                      <th>Out of TAT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {locationOptions.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.LOCNAME}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketDahboard;
